import * as React from "react";
import { useDashboard } from "@/contexts/DashboardContext.js";

// To enable ads, set the provider and supply config:
//   <AdSlot slot="home-bottom" provider="adsense" config={{ adClient: "ca-pub-XXX", adSlot: "123" }} />
//
// Supported providers: none (default). Add new providers to the switch below.

interface Props {
  slot: string;
  provider?: string;
  config?: Record<string, string>;
}

export function AdSlot({ slot, provider, config }: Props) {
  const { data: dashboard } = useDashboard();

  if (!provider || provider === "none") return null;

  // Don't show ads until user has reached activation milestone (5+ items)
  if (!dashboard?.onboarding?.hasReachedMilestone) return null;

  // Future: add cases for "adsense", "carbon", etc.
  return (
    <div data-ad-slot={slot} className="w-full flex justify-center py-4">
      <div className="text-xs text-gray-300">Ad</div>
    </div>
  );
}
